export const tagMap = {
  decaf: "5bcecdeef325036b0f66bb08",
  espresso: "5bcecdf6f325036b0f66bb09",
  ground: "5d8d9d61acdb795502d6ca74"
};
